"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventEmitter = void 0;
class EventEmitter {
    constructor() {
        this.listenersByConsumerId = new Map();
    }
    subscribe(consumerId, listener) {
        const listeners = this.getListenersForConsumerId(consumerId);
        listeners.add(listener);
        return () => listeners.delete(listener);
    }
    unsubscribeAll(consumerId) {
        this.getListenersForConsumerId(consumerId).clear();
    }
    emit() {
        for (const listeners of this.listenersByConsumerId.values()) {
            for (const listener of listeners) {
                listener();
            }
        }
    }
    getListenersForConsumerId(consumerId) {
        let listeners = this.listenersByConsumerId.get(consumerId);
        if (!listeners) {
            listeners = new Set();
            this.listenersByConsumerId.set(consumerId, listeners);
        }
        return listeners;
    }
}
exports.EventEmitter = EventEmitter;
//# sourceMappingURL=EventEmitter.js.map